// Startaplar uchun saytlar — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Startaplar uchun sayt va MVP yaratish — 6 mln so'mdan | Innobek",
        description:
            "Startaplar uchun sayt va MVP yaratish 6 000 000 so'mdan. G'oyani 7 kunda sinash sahifasi, ishlaydigan MVP esa 6–10 haftada. Analitika, to'lov va auth kiritilgan.",
        keywords: [
            "startap uchun sayt",
            "MVP yaratish",
            "startap sayti narxi",
            "g'oyani tez ishga tushirish",
            "MVP dasturlash Toshkent",
            "startap veb-ilova",
        ],
    },
    hero: {
        eyebrow: "Startaplar uchun saytlar",
        h1: "Startaplar uchun sayt va MVP yaratish — g'oyani tez ishga tushiring",
        lead:
            "Startapda eng qimmat narsa — vaqt. Biz avval talabni sinaydigan sahifani 7–10 kunda chiqaramiz, keyin foydalanuvchi haqiqatan ishlatadigan MVP'ni 6–10 haftada yig'amiz. Har bosqichda raqam ko'rinadi: ro'yxatdan o'tish, faollik, to'lov.",
        ctaPrimary: "G'oyani muhokama qilish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Sinov sahifasi 7–10 kunda",
            "MVP 6–10 haftada",
            "Analitika va metrikalar birinchi kundan",
            "Kod va infratuzilma sizniki",
        ],
    },
    intro: {
        h: "Startap sayti nima uchun oddiy saytdan farq qiladi?",
        p: [
            "Oddiy biznes saytida taklif allaqachon ma'lum: xizmat bor, mijoz bor, narx bor. Startapda esa buning hech biri hali isbotlanmagan. Shuning uchun startaplar uchun sayt birinchi navbatda tekshirish vositasi bo'ladi — u g'oyaga talab bor-yo'qligini pul va vaqt ko'p sarflanmasdan oldin ko'rsatishi kerak.",
            "Amalda biz ishni ikkiga bo'lamiz. Birinchi bosqich — muammoni, yechimni va taklifni tushuntiradigan sahifa hamda ro'yxatga yozilish shakli. U 7–10 kunda chiqadi va reklamaga ulanadi. Necha kishi bosgani, necha kishi qoldirgani ko'rinadi. Ikkinchi bosqich — shu raqamlar ma'qul bo'lsa, ishlaydigan MVP quriladi.",
            "MVP — bu qisqartirilgan mahsulot emas, balki bitta asosiy stsenariyni oxirigacha bajaradigan mahsulot. Foydalanuvchi ro'yxatdan o'tadi, asosiy vazifasini bajaradi va natija oladi. Qolgan hamma narsa — ikkinchi bosqich, ko'p rol, murakkab hisobot, mobil ilova — keyinga qoldiriladi. Aynan shu tanlov muddatni oylardan haftalarga tushiradi.",
            "Innobek startap loyihalarida ochiq ishlaydi. Har hafta oxirida siz ishlaydigan versiyani ko'rasiz va sinab ko'rasiz, hisobot o'qimaysiz. Vazifalar ro'yxati sizda ochiq turadi, ustuvorlikni birga o'zgartiramiz. Bu asosan investor demosi yoki grant muddati yaqinlashganda muhim bo'ladi.",
            "Biz nima bo'lmasligini ham aytamiz. Bir oyda tayyor bo'ladigan universal platforma yo'q. Agar sizga bir vaqtning o'zida veb, mobil ilova, admin panel va to'lov ekotizimi kerak bo'lsa, bu MVP emas, to'liq mahsulot — muddati ham, byudjeti ham boshqacha. Konsultatsiyada buni raqam bilan ko'rsatamiz.",
            "Texnologiya tanlashda ham xuddi shu mantiq ishlaydi. Startapga eng yangi emas, eng bashoratli asos kerak: React yoki Next.js, Node.js, PostgreSQL. Bular uchun dasturchi topish oson va hujjatlar to'liq. Shu sababli jamoa almashsa yoki siz o'z dasturchingizni yollasangiz, loyihani davom ettirish muammo bo'lmaydi. Nostandart texnologiyani faqat aniq sabab bo'lganda va sizga tushuntirib olamiz.",
        ],
    },
    definition: {
        term: "MVP nima?",
        text:
            "MVP — g'oyani bozorda sinash uchun yetarli bo'lgan eng kichik ishlaydigan mahsulot. Unda faqat bitta asosiy stsenariy to'liq bajariladi, qolgan funksiyalar esa birinchi foydalanuvchilar fikridan keyin qo'shiladi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifda standart tarzda bor",
        sub: "Startap loyihasida bu narsalar keyin emas, boshidan kerak bo'ladi.",
        items: [
            "G'oyani muhokama qilish va asosiy stsenariyni aniqlash",
            "Sinaladigan gipoteza va o'lchanadigan metrika ro'yxati",
            "Domen, hosting va SSL sozlash",
            "Mobil va desktop uchun moslashuvchan interfeys",
            "Google Analytics va voqealarni kuzatish",
            "Ro'yxatga yozilish shakli va Telegram xabarnomasi",
            "Meta teglar, sitemap.xml va Open Graph rasmi",
            "Git repozitoriya va kod arxivini topshirish",
            "Ishga tushirishdan keyin o'zgartirish kiritish uchun vaqt zaxirasi",
            "Topshirgandan keyin 6 oy texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Afzalliklari",
        h: "Nega startapda tez chiqish to'g'ri chiqishdan muhimroq",
        sub: "Bozor javobini olmaguningizcha, qaysi funksiya kerakligini hech kim bilmaydi.",
        items: [
            {
                t: "Byudjet bosqichga bo'linadi",
                d: "Hammasini birdan to'lamaysiz. Avval 6 000 000 so'mlik sinov sahifasi, keyin natijaga qarab MVP. Agar talab ko'rinmasa, katta byudjetni sarflamasdan to'xtatasiz.",
            },
            {
                t: "Haqiqiy raqam, taxmin emas",
                d: "Sahifa chiqqan kundan boshlab tashrif, bosish va ro'yxatga yozilish o'lchanadi. Konversiya 1% bo'lsa ham, bu tanishlarning maqtoviga qaraganda ko'proq ma'lumot beradi.",
            },
            {
                t: "Investor bilan suhbat osonlashadi",
                d: "Slaydda g'oya, ekranda esa ishlaydigan mahsulot va foydalanuvchi raqamlari bo'lsa, savol boshqacha qo'yiladi. Demo havolasi prezentatsiyadan kuchliroq ishlaydi.",
            },
            {
                t: "Texnik qarz to'planmaydi",
                d: "MVP tez yig'iladi, lekin toza arxitektura bilan. Keyinchalik funksiya qo'shilganda kod qayta yozilmaydi — bu ikkinchi bosqichda oy va pul tejaydi.",
            },
            {
                t: "Kod va infratuzilma sizniki",
                d: "Repozitoriya, domen, server va uchinchi tomon xizmatlari sizning nomingizga rasmiylashtiriladi. Jamoa almashsa ham, mahsulot sizda qoladi.",
            },
            {
                t: "Haftalik ko'rinadigan natija",
                d: "Har hafta oxirida ishlaydigan versiyaga havola olasiz. Yo'nalish noto'g'ri ketayotgan bo'lsa, bir hafta yo'qotasiz, uch oy emas.",
            },
            {
                t: "O'sishga tayyor asos",
                d: "Ma'lumotlar bazasi, autentifikatsiya va to'lov moduli standart yechimlar ustiga quriladi. Foydalanuvchi soni ortganda serverni kengaytirish oddiy ish bo'ladi.",
            },
            {
                t: "Keyingi bosqich aniq",
                d: "MVP topshirilgach, qaysi funksiya keyin kerakligi foydalanuvchi xatti-harakatidan ko'rinadi. Yo'l xaritasi taxmin asosida emas, ma'lumot asosida tuziladi.",
            },
            {
                t: "O'z jamoangizga topshirish oson",
                d: "Kod izohlangan, ma'lumotlar bazasi tuzilmasi va ishga tushirish tartibi hujjatlashtirilgan. O'z dasturchingizni yollasangiz, u loyihaga bir-ikki kunda kiradi — bizdan uzoq tushuntirish kutish shart emas.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimga mos",
        h: "Bu xizmat qaysi jamoalar uchun",
        sub: "Quyidagi holatlarda bosqichma-bosqich yondashuv eng tejamkor yo'l bo'ladi.",
        items: [
            {
                t: "G'oya bor, texnik hamkor yo'q",
                d: "Sohangizni yaxshi bilasiz, lekin dasturchi jamoangiz yo'q. Biz texnik qismni to'liq olamiz, siz mahsulot va mijozga qaraysiz.",
            },
            {
                t: "Grant yoki akselerator muddati",
                d: "IT Park, akselerator yoki tanlov uchun ishlaydigan prototip kerak. Muddat qattiq bo'lgani uchun ish rejasi teskari tartibda tuziladi.",
            },
            {
                t: "Investor demosiga tayyorgarlik",
                d: "Uchrashuvgacha havola qilinadigan ishlaydigan versiya va dastlabki foydalanuvchi raqamlari kerak bo'lganda.",
            },
            {
                t: "Mavjud biznesning yangi yo'nalishi",
                d: "Kompaniya ichida yangi mahsulot sinalayotganda. Asosiy biznesga tegilmaydi, yangi yo'nalish alohida sinaladi.",
            },
            {
                t: "SaaS va obuna mahsulotlari",
                d: "Foydalanuvchi ro'yxatdan o'tadi, tarif tanlaydi va to'laydi. Shu zanjir ishlashi MVP uchun yetarli isbot bo'ladi.",
            },
            {
                t: "Marketplace va platformalar",
                d: "Ikki tomonli bozorda avval bitta tomon sinaladi. Birinchi versiyada ko'p jarayon qo'lda bajariladi — bu normal va tez.",
            },
            {
                t: "Ichki jarayonni mahsulotga aylantirish",
                d: "Kompaniyangizda ishlayotgan jarayon boshqalarga ham foydali bo'lsa, uni alohida mahsulot sifatida chiqarish mumkin.",
            },
            {
                t: "Xorijiy bozorga chiqish",
                d: "Ingliz tilidagi sahifa va to'lov tizimi bilan chet el auditoriyasini sinash. Matn tarjima emas, o'sha bozor uchun qaytadan yoziladi.",
            },
            {
                t: "Mobil ilovadan oldingi bosqich",
                d: "Ilova qimmat va uzoq. Avval veb-versiyada talabni tekshirish, keyin mobil ilovaga o'tish arzonroq yo'l.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Startap sayti va MVP narxi",
        sub: "Bosqichma-bosqich to'lov. Har bosqich oxirida davom etish yoki to'xtash qarorini siz qabul qilasiz.",
        note:
            "Yakuniy hisob-kitob g'oyani muhokama qilgandan keyin, stsenariylar soni va integratsiyalarga qarab tasdiqlanadi. MVP bosqichi haftalik sprintlarga bo'linadi va har sprint oxirida ishlaydigan versiya topshiriladi. Server, domen va uchinchi tomon xizmatlari to'lovi alohida — odatda oyiga 200 000 – 1 500 000 so'm.",
        tiers: [
            {
                name: "Sinov sahifasi",
                tagline: "Talabni tekshirish uchun",
                price: "6 000 000",
                priceNote: "so'mdan",
                term: "7–10 ish kuni",
                best: "G'oyaga talab bor-yo'qligini bilmoqchi bo'lganlar uchun",
                features: [
                    "Muammo, yechim va taklifni ochadigan bir sahifali sayt",
                    "Ro'yxatga yozilish shakli va kutish ro'yxati",
                    "Analitika va voqealarni kuzatish",
                    "A/B sinov uchun ikkinchi sarlavha varianti",
                    "Reklama uchun UTM belgilash",
                    "Mobil va desktop moslashuvi",
                    "Telegram'ga xabarnoma",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "MVP",
                tagline: "Ishlaydigan birinchi versiya",
                price: "35 000 000",
                priceNote: "so'mdan",
                term: "6–10 hafta",
                best: "Foydalanuvchi haqiqatan ishlatadigan mahsulot kerak bo'lganda",
                featured: true,
                features: [
                    "Bitta asosiy stsenariy to'liq ishlaydigan holda",
                    "Ro'yxatdan o'tish va autentifikatsiya",
                    "Ma'lumotlar bazasi va admin panel",
                    "To'lov tizimi: Payme, Click yoki Stripe",
                    "Figma'da interfeys dizayni",
                    "Haftalik demo va ochiq vazifalar ro'yxati",
                    "Foydalanuvchi xatti-harakati metrikalar",
                    "Git repozitoriya va texnik hujjat",
                    "6 oy qo'llab-quvvatlash",
                ],
            },
            {
                name: "Scale",
                tagline: "MVP'dan keyingi bosqich",
                price: "80 000 000",
                priceNote: "so'mdan",
                term: "3 oydan boshlab",
                best: "Birinchi foydalanuvchilar kelgan va mahsulotni kengaytirish kerak bo'lganda",
                features: [
                    "Bir nechta rol va murakkab huquqlar tizimi",
                    "Mobil ilova yoki PWA versiyasi",
                    "Tashqi tizimlar bilan API integratsiyasi",
                    "Yuklama ostida ishlash uchun infratuzilma",
                    "Avtomatik testlar va CI/CD",
                    "Monitoring, loglar va xatolarni kuzatish",
                    "Ma'lumotlar tahlili va hisobotlar",
                    "Doimiy jamoa va oylik reja bo'yicha ish",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "G'oyadan ishlaydigan mahsulotgacha",
        sub: "Olti bosqich. Har bosqich oxirida to'xtash yoki davom etish qarori sizda qoladi.",
        steps: [
            {
                t: "G'oyani muhokama qilish",
                time: "1–2 kun",
                d: "Qanday muammoni yechayotganingizni, kim uchun va nima evaziga pul olishingizni aniqlaymiz. Shu suhbatdan sinaladigan gipoteza va o'lchanadigan metrika chiqadi.",
            },
            {
                t: "Talabni sinash",
                time: "7–10 kun",
                d: "Sahifa chiqariladi va reklamaga ulanadi. Ikki-uch hafta ichida qancha odam qiziqqanini raqamda ko'rasiz. Natija yomon bo'lsa, taklifni o'zgartiramiz.",
            },
            {
                t: "MVP doirasini belgilash",
                time: "3–5 kun",
                d: "Birinchi versiyaga nima kiradi va nima kirmasligini yozib chiqamiz. Bu ro'yxat qattiq: qo'shimcha g'oyalar ikkinchi bosqich ro'yxatiga yoziladi.",
            },
            {
                t: "Dizayn va arxitektura",
                time: "1–2 hafta",
                d: "Asosiy ekranlar Figma'da chiziladi, ma'lumotlar bazasi tuzilmasi va texnologiyalar tanlanadi. Tanlov o'sish imkoniyatini hisobga olib qilinadi.",
            },
            {
                t: "Haftalik sprintlar",
                time: "4–8 hafta",
                d: "Har hafta oxirida ishlaydigan versiyaga havola olasiz va sinab ko'rasiz. Ustuvorlikni birgalikda o'zgartiramiz — reja qotib qolgan hujjat emas.",
            },
            {
                t: "Ishga tushirish va kuzatuv",
                time: "6 oy",
                d: "Mahsulot serverga chiqariladi, metrikalar va xatolarni kuzatish sozlanadi. Birinchi foydalanuvchilar fikriga qarab tuzatishlar kiritiladi.",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "So'nggi ishlarimizdan",
        sub: "Quyidagi mahsulotlar ham kichik versiyadan boshlangan va foydalanuvchi fikri bilan o'sgan.",
        cta: "Barcha loyihalar",
        slugs: ["firewise", "rememberme", "imtihan", "elma-lms"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Startap sayti va MVP yaratish bo'yicha eng ko'p so'raladigan savollar.",
        items: [
            {
                q: "Startap uchun sayt yaratish qancha turadi?",
                a: "Talabni sinaydigan sahifa 6 000 000 so'mdan boshlanadi va 7–10 kunda tayyor bo'ladi. Ishlaydigan MVP 35 000 000 so'mdan, muddati 6–10 hafta. MVP'dan keyingi kengaytirish bosqichi 80 000 000 so'mdan. Aniq raqam stsenariylar soni va integratsiyalarga qarab konsultatsiyadan keyin belgilanadi.",
            },
            {
                q: "MVP yaratish qancha vaqt oladi?",
                a: "Odatda 6–10 hafta. Muddat asosiy stsenariylar soniga bog'liq: bitta rol va bitta jarayon bo'lsa, olti hafta yetadi. Bir nechta rol, to'lov va tashqi integratsiya qo'shilsa, o'n haftaga chiqadi. Har hafta oxirida ishlaydigan versiyani ko'rib borasiz. Shu sababli muddat oxirida kutilmagan natija chiqmaydi va tuzatish arzon tushadi.",
            },
            {
                q: "MVP bilan to'liq mahsulot orasidagi farq nima?",
                a: "MVP bitta asosiy stsenariyni oxirigacha bajaradi va shu bilan cheklanadi. To'liq mahsulotda esa ko'p rol, murakkab hisobotlar, mobil ilova va kengaytirilgan sozlamalar bo'ladi. MVP maqsadi — mukammallik emas, bozor javobini eng tez va eng arzon yo'l bilan olish. Qolgan funksiyalar birinchi foydalanuvchilar fikridan keyin qo'shiladi.",
            },
            {
                q: "Avval sinov sahifasi shartmi, to'g'ridan-to'g'ri MVP qilsa bo'ladimi?",
                a: "Shart emas, lekin tavsiya qilamiz. Sinov sahifasi bir haftada chiqadi va bir necha million so'm turadi. Agar u hech qanday qiziqish ko'rsatmasa, o'ttiz million so'mlik MVP'ni qurmasdan taklifni qayta ko'rib chiqasiz. Talab allaqachon isbotlangan bo'lsa, to'g'ridan-to'g'ri MVP'dan boshlaymiz. Bu qarorni sizga biz emas, raqamlar aytadi.",
            },
            {
                q: "Qanday texnologiyalar ishlatiladi?",
                a: "Frontend uchun React yoki Next.js, backend uchun Node.js yoki NestJS, ma'lumotlar bazasi sifatida PostgreSQL. Tez chiqish kerak bo'lganda Supabase yoki Firebase ishlatiladi. Tanlov mahsulotga qarab qilinadi va sabablari sizga tushuntiriladi — nostandart texnologiyani sabab bo'lmasa olmaymiz. Tanlangan stek bo'yicha bozorda dasturchi topish oson bo'lishi ham hisobga olinadi.",
            },
            {
                q: "Kod kimga tegishli bo'ladi?",
                a: "Sizga. Repozitoriya sizning akkauntingizda ochiladi, domen va server sizning nomingizga rasmiylashtiriladi, uchinchi tomon xizmatlari kalitlari ham sizda bo'ladi. Shartnomada mulk huquqi alohida yoziladi. Jamoa almashsa yoki boshqa dasturchi kelsa, mahsulot sizda qoladi. Topshirishda texnik hujjat va ishga tushirish tartibi ham beriladi, shuning uchun yangi dasturchi loyihaga tez kiradi.",
            },
            {
                q: "To'lov tizimini ulash mumkinmi?",
                a: "Ha. Mahalliy bozor uchun Payme, Click va Uzum, xorijiy auditoriya uchun Stripe yoki Paddle ulanadi. Ulash texnik ish sifatida MVP tarifiga kiradi, lekin shartnoma va hujjatlarni to'lov provayderi bilan siz rasmiylashtirasiz — bu yuridik shaxs nomiga bog'liq. Kerakli hujjatlar ro'yxatini beramiz va to'ldirishda yordam qilamiz.",
            },
            {
                q: "Loyiha davomida g'oya o'zgarsa nima bo'ladi?",
                a: "Bu startapda odatiy hol. Ish haftalik sprintlarga bo'lingani uchun yo'nalishni sprint boshida o'zgartirish mumkin. Umumiy hajm o'zgarmasa, narx ham o'zgarmaydi. Agar yangi talablar hajmni sezilarli oshirsa, qo'shimcha ishni oldindan baholaymiz va kelishamiz. Hech qanday qo'shimcha ish sizning yozma tasdiqingizsiz boshlanmaydi va hisobga qo'shilmaydi.",
            },
            {
                q: "Startapga mobil ilova kerakmi?",
                a: "Boshida odatda kerak emas. Mobil ilova qimmatroq, uzoqroq va do'kon moderatsiyasiga bog'liq. Avval veb-versiyada talabni tekshirish arzonroq. Foydalanuvchilar muntazam qaytadigan bo'lsa yoki bildirishnoma kerak bo'lsa, keyingi bosqichda ilovaga o'tamiz. Ko'p hollarda mobil brauzer uchun moslashtirilgan PWA versiyasi yetarli bo'ladi va u sezilarli arzonroq tushadi.",
            },
            {
                q: "MVP topshirilgandan keyin nima bo'ladi?",
                a: "Olti oy davomida texnik xatolar bepul tuzatiladi va mahsulot ishlashi kuzatiladi. Yangi funksiyalar alohida kelishiladi: oylik doimiy jamoa formatida yoki alohida vazifalar sifatida. Ko'p jamoalar ikkinchi oydan boshlab oylik rejimga o'tadi, chunki foydalanuvchi fikri tez keladi. Oylik formatning hajmi oldindan kelishiladi va uni istalgan oyda to'xtatish mumkin.",
            },
            {
                q: "Bu xizmat qachon mos kelmaydi?",
                a: "Agar sizga bir vaqtning o'zida veb, mobil ilova, admin panel va murakkab integratsiyalar kerak bo'lsa, bu MVP emas. Bunday loyiha uchun veb-ilova yoki korporativ tizim ishlab chiqish xizmatiga qarang. Shuningdek, talab allaqachon isbotlangan va yuklama katta bo'lsa, to'g'ridan-to'g'ri Scale bosqichidan boshlanadi.",
            },
            {
                q: "Toshkentdan tashqarida bo'lsam ishlay olasizmi?",
                a: "Ha. Startap loyihalarining katta qismini masofadan olib boramiz: haftalik demo onlayn, vazifalar ro'yxati ochiq, muloqot Telegram orqali. O'zbekistonning istalgan viloyatidan hamda chet eldan buyurtma qabul qilamiz. Bog'lanish uchun: +998 90 954 12 62. Shartnoma va hisob-faktura O'zbekiston qonunchiligi bo'yicha rasmiylashtiriladi. Toshkentda ofisda uchrashish ham mumkin.",
            },
        ],
    },
    cta: {
        h: "G'oyangizni muhokama qilamizmi?",
        p: "Bepul suhbatda g'oyani bosqichlarga bo'lamiz, birinchi versiyaga nima kirishini aytamiz va aniq narx bilan muddatni belgilaymiz. Majburiyat yo'q. Telefon: +998 90 954 12 62.",
        button: "G'oyani muhokama qilish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Startap uchun MVP interfeysi noutbuk va telefon ekranida ko'rsatilgan",
            caption: "MVP bitta asosiy stsenariyni oxirigacha bajaradi — qolgani keyingi bosqichga.",
        },
        {
            src: "/assets/img/projects/firewise.webp",
            alt: "Firewise startapi uchun veb-platforma: boshqaruv paneli va hisobotlar",
            caption: "Firewise — kichik versiyadan boshlanib, foydalanuvchi fikri bilan o'sgan mahsulot.",
        },
        {
            src: "/assets/img/projects/rememberme.webp",
            alt: "RememberMe startap sayti: ro'yxatdan o'tish va asosiy stsenariy ekrani",
            caption: "RememberMe — g'oyani tez chiqarish uchun qurilgan birinchi versiya.",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "Startap metrikalar paneli: ro'yxatga yozilish, faollik va to'lov ko'rsatkichlari",
            caption: "Metrikalar birinchi kundan sozlanadi — qaror taxminga emas, raqamga tayanadi.",
        },
        {
            src: "/assets/img/projects/imtihan.webp",
            alt: "Imtihan ta'lim platformasi MVP: test topshirish va natija ekrani",
            caption: "Imtihan — bitta stsenariydan boshlangan ta'lim platformasi.",
        },
    ],
    related: ["landing-page", "veb-ilovalar", "mobil-ilova", "ux-ui-dizayn", "ai-integratsiya"],
};

const ru = {
    meta: {
        title: "Сайты для стартапов и разработка MVP — от 6 млн сум | Innobek",
        description:
            "Сайт для стартапа и разработка MVP от 6 000 000 сум. Страница проверки спроса за 7 дней, рабочий MVP — за 6–10 недель. Аналитика, оплата и авторизация включены.",
        keywords: [
            "сайт для стартапа",
            "разработка MVP",
            "цена MVP",
            "быстрый запуск идеи",
            "MVP Ташкент",
            "веб-приложение для стартапа",
        ],
    },
    hero: {
        eyebrow: "Сайты для стартапов",
        h1: "Сайт для стартапа и разработка MVP — запустите идею быстро",
        lead:
            "В стартапе дороже всего стоит время. Сначала мы за 7–10 дней выпускаем страницу, которая проверяет спрос, затем за 6–10 недель собираем MVP, которым люди реально пользуются. На каждом этапе видны цифры: регистрации, активность, оплаты.",
        ctaPrimary: "Обсудить идею",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Страница проверки за 7–10 дней",
            "MVP за 6–10 недель",
            "Аналитика с первого дня",
            "Код и инфраструктура ваши",
        ],
    },
    intro: {
        h: "Чем сайт для стартапа отличается от обычного сайта",
        p: [
            "У обычного бизнеса предложение уже известно: есть услуга, есть клиент, есть цена. В стартапе ничего из этого пока не доказано. Поэтому сайт для стартапа — в первую очередь инструмент проверки: он должен показать, есть ли спрос на идею, до того как на неё потрачены большие деньги и месяцы работы.",
            "На практике мы делим работу надвое. Первый этап — страница, которая объясняет проблему, решение и предложение, плюс форма записи в лист ожидания. Она выходит за 7–10 дней и подключается к рекламе. Видно, сколько человек кликнуло и сколько оставило контакт. Второй этап — если цифры устраивают, собираем рабочий MVP.",
            "MVP — это не урезанный продукт, а продукт, который доводит до конца один основной сценарий. Пользователь регистрируется, выполняет свою главную задачу и получает результат. Всё остальное — второстепенные роли, сложные отчёты, мобильное приложение — откладывается. Именно такой отбор сокращает срок с месяцев до недель.",
            "На стартап-проектах Innobek работает открыто. В конце каждой недели вы получаете рабочую версию и пробуете её сами, а не читаете отчёт. Список задач доступен вам постоянно, приоритеты меняем вместе. Это особенно важно, когда приближается демо для инвестора или дедлайн гранта.",
            "Мы честно говорим и о том, чего не бывает. Универсальной платформы, готовой за месяц, не существует. Если вам одновременно нужны веб, мобильное приложение, админка и платёжная экосистема — это не MVP, а полноценный продукт с другим сроком и бюджетом. На консультации показываем разницу в цифрах.",
            "К выбору технологий подход тот же. Стартапу нужна не самая новая, а самая предсказуемая основа: React или Next.js, Node.js, PostgreSQL. Под них легко найти разработчика, документация полная. Поэтому при смене команды или найме собственного программиста продолжить проект не составит труда. Нестандартный стек берём только при явной причине и объясняем её вам.",
        ],
    },
    definition: {
        term: "Что такое MVP?",
        text:
            "MVP — минимально работающий продукт, которого достаточно, чтобы проверить идею на рынке. В нём полностью реализован один основной сценарий, а остальные функции добавляются после отзывов первых пользователей.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "В стартап-проекте это нужно с самого начала, а не когда-нибудь потом.",
        items: [
            "Разбор идеи и определение основного сценария",
            "Список проверяемых гипотез и измеримых метрик",
            "Настройка домена, хостинга и SSL",
            "Адаптивный интерфейс для мобильных и десктопа",
            "Google Analytics и отслеживание событий",
            "Форма записи и уведомления в Telegram",
            "Метатеги, sitemap.xml и картинка Open Graph",
            "Git-репозиторий и передача архива кода",
            "Запас времени на правки после запуска",
            "6 месяцев техподдержки после сдачи",
        ],
    },
    benefits: {
        eyebrow: "Преимущества",
        h: "Почему в стартапе выйти быстро важнее, чем выйти идеально",
        sub: "Пока рынок не ответил, никто не знает, какая функция действительно нужна.",
        items: [
            {
                t: "Бюджет делится по этапам",
                d: "Платить всё сразу не нужно. Сначала страница проверки за 6 000 000 сум, затем MVP — уже по результату. Если спроса нет, вы останавливаетесь, не потратив крупную сумму.",
            },
            {
                t: "Реальные цифры вместо догадок",
                d: "С первого дня считаются визиты, клики и записи. Даже конверсия в 1% говорит о рынке больше, чем одобрение знакомых и коллег.",
            },
            {
                t: "Проще разговор с инвестором",
                d: "Когда на слайде идея, а на экране работающий продукт с цифрами пользователей, разговор идёт иначе. Ссылка на демо убеждает сильнее презентации.",
            },
            {
                t: "Без накопления техдолга",
                d: "MVP собирается быстро, но на чистой архитектуре. При добавлении функций код не переписывается заново — это экономит месяцы и деньги на втором этапе.",
            },
            {
                t: "Код и инфраструктура ваши",
                d: "Репозиторий, домен, сервер и сторонние сервисы оформляются на вас. Даже при смене команды продукт остаётся в ваших руках.",
            },
            {
                t: "Видимый результат каждую неделю",
                d: "В конце недели вы получаете ссылку на рабочую версию. Если направление неверное, вы теряете неделю, а не три месяца.",
            },
            {
                t: "База, готовая к росту",
                d: "База данных, авторизация и оплата строятся на проверенных решениях. Когда пользователей станет больше, масштабирование будет рутинной задачей.",
            },
            {
                t: "Понятный следующий шаг",
                d: "После сдачи MVP видно по поведению пользователей, какая функция нужна следующей. Дорожная карта строится на данных, а не на предположениях.",
            },
            {
                t: "Легко передать своей команде",
                d: "Код прокомментирован, структура базы данных и порядок развёртывания описаны. Нанятый вами разработчик входит в проект за пару дней, без долгих объяснений с нашей стороны.",
            },
        ],
    },
    audience: {
        eyebrow: "Кому подходит",
        h: "Каким командам это подойдёт",
        sub: "В этих ситуациях поэтапный подход оказывается самым экономным путём.",
        items: [
            {
                t: "Есть идея, нет технического партнёра",
                d: "Вы хорошо знаете свою сферу, но у вас нет команды разработки. Мы берём техническую часть, вы занимаетесь продуктом и клиентами.",
            },
            {
                t: "Дедлайн гранта или акселератора",
                d: "Для IT Park, акселератора или конкурса нужен работающий прототип. Срок жёсткий, поэтому план работ строим от даты назад.",
            },
            {
                t: "Подготовка к демо для инвестора",
                d: "Когда к встрече нужна рабочая версия по ссылке и первые цифры по пользователям, а не только презентация.",
            },
            {
                t: "Новое направление действующего бизнеса",
                d: "Компания проверяет новый продукт внутри себя. Основной бизнес не трогаем, направление тестируется отдельно.",
            },
            {
                t: "SaaS и подписочные продукты",
                d: "Пользователь регистрируется, выбирает тариф и платит. Работоспособность этой цепочки — достаточное доказательство для MVP.",
            },
            {
                t: "Маркетплейсы и платформы",
                d: "На двустороннем рынке сначала проверяется одна сторона. В первой версии часть процессов делается вручную — это нормально и быстро.",
            },
            {
                t: "Внутренний процесс как продукт",
                d: "Если отлаженный у вас процесс полезен и другим компаниям, его можно вывести на рынок отдельным продуктом.",
            },
            {
                t: "Выход на зарубежный рынок",
                d: "Страница на английском и платёжная система для проверки иностранной аудитории. Текст не переводится, а пишется заново под этот рынок.",
            },
            {
                t: "Этап перед мобильным приложением",
                d: "Приложение дорого и долго. Дешевле проверить спрос в вебе и только потом переходить к мобильной версии.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость сайта для стартапа и MVP",
        sub: "Оплата по этапам. В конце каждого этапа решение продолжать или остановиться принимаете вы.",
        note:
            "Итоговая смета подтверждается после разбора идеи и зависит от числа сценариев и интеграций. Этап MVP делится на недельные спринты, в конце каждого сдаётся работающая версия. Сервер, домен и сторонние сервисы оплачиваются отдельно — обычно 200 000 – 1 500 000 сум в месяц.",
        tiers: [
            {
                name: "Проверка спроса",
                tagline: "Страница для теста идеи",
                price: "6 000 000",
                priceNote: "сум",
                term: "7–10 рабочих дней",
                best: "Тем, кто хочет понять, есть ли спрос на идею",
                features: [
                    "Одностраничный сайт: проблема, решение, предложение",
                    "Форма записи и лист ожидания",
                    "Аналитика и отслеживание событий",
                    "Второй вариант заголовка для A/B-теста",
                    "UTM-разметка под рекламу",
                    "Адаптация под мобильные и десктоп",
                    "Уведомления в Telegram",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "MVP",
                tagline: "Работающая первая версия",
                price: "35 000 000",
                priceNote: "сум",
                term: "6–10 недель",
                best: "Когда нужен продукт, которым реально пользуются",
                featured: true,
                features: [
                    "Один основной сценарий, доведённый до конца",
                    "Регистрация и авторизация",
                    "База данных и админ-панель",
                    "Приём оплаты: Payme, Click или Stripe",
                    "Дизайн интерфейса в Figma",
                    "Еженедельные демо и открытый список задач",
                    "Метрики поведения пользователей",
                    "Git-репозиторий и техническая документация",
                    "6 месяцев поддержки",
                ],
            },
            {
                name: "Scale",
                tagline: "Этап после MVP",
                price: "80 000 000",
                priceNote: "сум",
                term: "от 3 месяцев",
                best: "Когда пришли первые пользователи и продукт пора расширять",
                features: [
                    "Несколько ролей и гибкая система прав",
                    "Мобильное приложение или PWA",
                    "Интеграции по API с внешними системами",
                    "Инфраструктура под нагрузку",
                    "Автотесты и CI/CD",
                    "Мониторинг, логи и отслеживание ошибок",
                    "Аналитика данных и отчёты",
                    "Постоянная команда и работа по месячному плану",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "От идеи до работающего продукта",
        sub: "Шесть этапов. В конце каждого решение остановиться или продолжать остаётся за вами.",
        steps: [
            {
                t: "Разбор идеи",
                time: "1–2 дня",
                d: "Определяем, какую проблему вы решаете, для кого и за счёт чего зарабатываете. Из этого разговора рождаются проверяемые гипотезы и измеримые метрики.",
            },
            {
                t: "Проверка спроса",
                time: "7–10 дней",
                d: "Выпускаем страницу и подключаем рекламу. За две-три недели вы видите в цифрах, сколько людей заинтересовалось. Если результат слабый, меняем предложение.",
            },
            {
                t: "Определение объёма MVP",
                time: "3–5 дней",
                d: "Фиксируем, что входит в первую версию, а что нет. Список жёсткий: дополнительные идеи уходят в бэклог второго этапа.",
            },
            {
                t: "Дизайн и архитектура",
                time: "1–2 недели",
                d: "Рисуем ключевые экраны в Figma, продумываем структуру базы данных и выбираем технологии. Выбор делается с расчётом на дальнейший рост.",
            },
            {
                t: "Недельные спринты",
                time: "4–8 недель",
                d: "Каждую неделю вы получаете ссылку на рабочую версию и тестируете её. Приоритеты меняем вместе: план — не застывший документ.",
            },
            {
                t: "Запуск и наблюдение",
                time: "6 месяцев",
                d: "Выкатываем продукт на сервер, настраиваем метрики и отслеживание ошибок. По отзывам первых пользователей вносим правки.",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Из недавних работ",
        sub: "Эти продукты тоже начинались с небольшой версии и росли по отзывам пользователей.",
        cta: "Все проекты",
        slugs: ["firewise", "rememberme", "imtihan", "elma-lms"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Самое частое, о чём спрашивают про сайты для стартапов и разработку MVP.",
        items: [
            {
                q: "Сколько стоит сайт для стартапа?",
                a: "Страница для проверки спроса стоит от 6 000 000 сум и делается за 7–10 дней. Работающий MVP — от 35 000 000 сум, срок 6–10 недель. Этап расширения после MVP начинается от 80 000 000 сум. Точная сумма определяется после разбора идеи и зависит от числа сценариев и интеграций.",
            },
            {
                q: "Сколько времени занимает разработка MVP?",
                a: "Обычно 6–10 недель. Срок зависит от количества основных сценариев: при одной роли и одном процессе хватает шести недель. Если добавляются несколько ролей, оплата и внешние интеграции, выходит десять. Рабочую версию вы видите в конце каждой недели. Поэтому к концу срока не бывает неожиданностей.",
            },
            {
                q: "Чем MVP отличается от полноценного продукта?",
                a: "MVP доводит до конца один основной сценарий и на этом останавливается. В полноценном продукте есть несколько ролей, сложные отчёты, мобильное приложение и расширенные настройки. Цель MVP не в полноте функций, а в том, чтобы получить ответ рынка быстро и недорого.",
            },
            {
                q: "Обязательно ли начинать со страницы проверки?",
                a: "Не обязательно, но мы рекомендуем. Такая страница делается за неделю и стоит несколько миллионов сум. Если интереса нет, вы пересмотрите предложение, не потратив тридцать с лишним миллионов на MVP. Когда спрос уже доказан, начинаем сразу с разработки. Это решение подсказывают цифры, а не мы.",
            },
            {
                q: "Какие технологии вы используете?",
                a: "На фронтенде React или Next.js, на бэкенде Node.js либо NestJS, в качестве базы данных PostgreSQL. Когда нужно выйти особенно быстро, применяем Supabase или Firebase. Выбор делается под конкретный продукт, и мы объясняем его причины. Экзотические технологии без повода не берём.",
            },
            {
                q: "Кому принадлежит код?",
                a: "Вам. Репозиторий открывается в вашем аккаунте, домен и сервер оформляются на вас, ключи сторонних сервисов тоже остаются у вас. Права собственности прописываются в договоре. При смене команды или подключении другого разработчика продукт остаётся вашим. При сдаче передаём и техническую документацию с описанием развёртывания.",
            },
            {
                q: "Можно ли подключить приём оплаты?",
                a: "Да. Для местного рынка подключаем Payme, Click и Uzum, для зарубежной аудитории — Stripe или Paddle. Техническая интеграция входит в тариф MVP, но договор с платёжным провайдером оформляете вы сами: это привязано к вашему юридическому лицу. Список нужных документов мы даём и помогаем их заполнить.",
            },
            {
                q: "Что если идея изменится по ходу работы?",
                a: "Для стартапа это норма. Работа разбита на недельные спринты, поэтому направление можно менять в начале спринта. Если общий объём остаётся прежним, цена не меняется. Когда новые требования заметно увеличивают объём, оцениваем и согласовываем доработку заранее. Без вашего письменного подтверждения работа не начинается.",
            },
            {
                q: "Нужно ли стартапу мобильное приложение?",
                a: "На старте обычно нет. Приложение дороже, дольше и зависит от модерации в магазинах. Дешевле проверить спрос в веб-версии. Если пользователи возвращаются регулярно или нужны push-уведомления, к приложению переходим на следующем этапе. Часто хватает PWA-версии под мобильный браузер: она заметно дешевле и быстрее.",
            },
            {
                q: "Что происходит после сдачи MVP?",
                a: "Полгода мы бесплатно исправляем технические ошибки и следим за работой продукта. Новые функции берём отдельно: либо постоянной командой по месячному формату, либо отдельными задачами. Многие со второго месяца переходят на месячный формат, потому что обратная связь идёт быстро. Объём работ согласуется заранее, и договор можно прекратить в любой месяц.",
            },
            {
                q: "Когда эта услуга не подходит?",
                a: "Если вам сразу нужны веб, мобильное приложение, админка и сложные интеграции — это уже не MVP. Для таких проектов посмотрите разработку веб-приложений или корпоративных систем. Если спрос доказан и нагрузка большая, начинаем сразу с этапа Scale. На консультации честно скажем, какой вариант вам подходит.",
            },
            {
                q: "Вы работаете, если я не в Ташкенте?",
                a: "Да. Большинство стартап-проектов ведём удалённо: еженедельные демо онлайн, открытый список задач, общение в Telegram. Принимаем заказы из любого региона Узбекистана и из-за рубежа. Телефон для связи: +998 90 954 12 62. Договор и счёт оформляем по законодательству Узбекистана. При желании встречаемся в офисе в Ташкенте.",
            },
        ],
    },
    cta: {
        h: "Обсудим вашу идею?",
        p: "На бесплатной встрече разложим идею по этапам, определим, что войдёт в первую версию, и зафиксируем точную цену и срок. Без обязательств. Телефон: +998 90 954 12 62.",
        button: "Обсудить идею",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Интерфейс MVP для стартапа на экране ноутбука и телефона",
            caption: "MVP доводит до конца один основной сценарий — остальное на следующий этап.",
        },
        {
            src: "/assets/img/projects/firewise.webp",
            alt: "Веб-платформа стартапа Firewise: панель управления и отчёты",
            caption: "Firewise — продукт, выросший из небольшой версии по отзывам пользователей.",
        },
        {
            src: "/assets/img/projects/rememberme.webp",
            alt: "Сайт стартапа RememberMe: экран регистрации и основной сценарий",
            caption: "RememberMe — первая версия, собранная для быстрого выхода на рынок.",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "Панель метрик стартапа: регистрации, активность и оплаты",
            caption: "Метрики настраиваются с первого дня — решения опираются на цифры.",
        },
        {
            src: "/assets/img/projects/imtihan.webp",
            alt: "MVP образовательной платформы Imtihan: прохождение теста и результат",
            caption: "Imtihan — образовательная платформа, начавшаяся с одного сценария.",
        },
    ],
    related: ["landing-page", "veb-ilovalar", "mobil-ilova", "ux-ui-dizayn", "ai-integratsiya"],
};

const content = { uz, ru };

export default content;
